import { httpClient } from '../http/httpClient'

export interface UserPinParams {
  oldPassword?: string
  pin: string
}

export const userPin = async (pinData: UserPinParams) => {
  const { data } = await httpClient
    .patch('/user/me/password', pinData)
    .catch((e) => {
      throw e?.response?.data || e
    })

  return data
}
